import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { PoiService } from '../../../services/POI/poi.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarSuccessComponent } from '../../../components/core/snackBar/snack-bar-success/snack-bar-success.component';
import { TranslateService } from '@ngx-translate/core';
import { IFacility } from '../../../interface/facility';
import { IFeature } from '../../../interface/feature';
import { MapboxService } from '../../../services/mapbox/mapbox.service';
import {map, switchMap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { LoadingService } from '../../../services/loading/loading.service';
import { SpaceValidation } from '../../../validators/space-validator';


@Component({
  selector: 'app-add-facility-dialog',
  templateUrl: './add-facility-dialog.component.html',
  styleUrls: ['./add-facility-dialog.component.scss']
})
export class AddFacilityDialogComponent implements OnInit, OnDestroy {

  type: string;
  isLoading: boolean;
  isLoadingSubscription: Subscription;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  facility: IFacility;
  isLinear = false;
  feature: IFeature;
  feautures: Array<IFeature> = [];
  lat: any;
  lng: any;

  image: any;
  file: File;
  fileName: string;
  poiSheet: any;

  constructor(
    private dialogRef: MatDialogRef<AddFacilityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
    private formBuilder: FormBuilder,
    private POIService: PoiService,
    private mapboxService: MapboxService,
    private translateService: TranslateService,
    private matSnackBar: MatSnackBar,
    private loadingService: LoadingService,
    private spaceValidation: SpaceValidation
  ) {
    this.type = data;
    this.isLoadingSubscription = this.loadingService.getLoadingStatus().subscribe(status => this.isLoading = status);
  }


  ngOnInit() {
    this.checkFirstForm();
    this.checkSecondForm();
  }

  fileChangeEvent(event: any) {
    if (event.target.files && event.target.files[0]) {
      // tslint:disable-next-line:prefer-const
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event: any) => { this.image = event.target.result; }
      this.file = event.target.files[0];
      this.POIService.uploadMediaFile(this.file, 'Geolocation').subscribe(res => {
        this.poiSheet = {
          poiId: 0,
          sheet: {
            id: 0,
            attachments: [{
              id: 0,
              fileName: res,
              type: 'Image',
              langInfos: []
            }],
            langInfos: []
          }
        }
      });
    }
  }

  checkFirstForm() {
    this.firstFormGroup = this.formBuilder.group({
      language: [null, Validators.required],
      infos: this.formBuilder.array([])
    });
  }

  get f() { return this.firstFormGroup.controls; }

  get infosForms() {
    return this.firstFormGroup.get('infos') as FormArray;
  }

  onChangeLanguages(language: string) {
    const info = this.formBuilder.group({
      languageCode: [language],
      name: [null, [Validators.required, this.spaceValidation.checkSpaceValidation]],
      address: [null, [Validators.required, this.spaceValidation.checkSpaceValidation]]
    });

    if (this.infosForms.length > 0) {
      this.checkIfInfoExist(info);
    } else {
      this.infosForms.push(info);
    }
  }

  checkIfInfoExist(info: any) {
    let find: boolean;

    this.infosForms.controls.forEach((item) => {
      if (item.get('languageCode').value === info.get('languageCode').value) {
        find = true;
        return;
      }
    });

    if (!find) {
      this.infosForms.push(info);
    }
  }

  removeLanguage(index: number) {
    this.infosForms.removeAt(index);
    this.firstFormGroup.get('language').reset();
  }

  // Search place
  search(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    if (searchTerm && searchTerm.length >= 3) {
      this.feature = null;
      this.mapboxService.searchPoi(searchTerm).subscribe(res => {
        this.feautures = [];
        res.map(feature => {
          this.feautures.push({
            place_name: feature.place_name,
            city: '',
            latitude: feature.geometry.coordinates[1],
            longitude: feature.geometry.coordinates[0]
          });
        });
      });
    } else {
      this.feautures = [];
    }
  }

  // Select place
  addressesSelected(optionSelected: string) {
    const address: string = optionSelected;
    this.feautures.forEach(feature => {
      if (feature.place_name === address) {
        this.feature = feature;
      }
    });
    this.lat = this.feature.latitude;
    this.lng = this.feature.longitude;
    this.secondFormGroup.get('latitude').setValue(this.lat);
    this.secondFormGroup.get('longitude').setValue(this.lng);
  }

  checkSecondForm() {
    this.secondFormGroup = this.formBuilder.group({
      id: [''],
      email: [null, Validators.email],
      latitude: [null, Validators.required],
      longitude: [null, Validators.required],
      city: [null],
      phone: [null, [Validators.pattern('^[+]{0,1}[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\\\s\\\\./0-9]*$')]],
      uniqueCode: [null, /*[Validators.pattern('^[a-zA-Z0-9]{0,7}$')]*/ Validators.required],
      maxPromoCount: [0, [Validators.pattern('^[0-9.]+$')]],
      disabled: [false],
      vat: [null, [Validators.pattern('(IT)?[0-9]{11}')]],
    });
  }

  //Method that closed dialog
  closeDialog() {
    this.dialogRef.close();
  }

  onSubmit() {
    if (this.secondFormGroup.invalid || this.firstFormGroup.invalid) {
      return;
    }

    this.facility = {
      email: this.secondFormGroup.value.email,
      phone: this.secondFormGroup.value.phone,
      vat: this.secondFormGroup.value.vat,
      uniqueCode: this.secondFormGroup.value.uniqueCode,
      maxPromoCount: this.secondFormGroup.value.maxPromoCount,
      id: 0,
      latitude: this.secondFormGroup.value.latitude,
      longitude: this.secondFormGroup.value.longitude,
      city: this.secondFormGroup.value.city,
      type: this.type,
      disabled: this.secondFormGroup.value.disabled,
      langInfos: this.firstFormGroup.value.infos,
      actionARadius: 0,
      tolerance: 0
    };
    this.facilityUpsert(this.facility);
  }

  facilityUpsert(facility: IFacility) {
    this.isLoading = true;
    if (this.poiSheet) {
      this.POIService.facilityUpsert(facility).pipe(
        map((res: any) => this.poiSheet.poiId = res.value),
        switchMap(res => this.POIService.upsertPoiSheet(this.poiSheet))
      ).subscribe(res => {
        this.isLoading = false;
        this.translateService.get('FacilityCreate_200').subscribe(res =>
          this.matSnackBar.openFromComponent(SnackBarSuccessComponent, {
            data: res.title,
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'right'
          }));
        this.closeDialog();
      });
    } else {
      this.POIService.facilityUpsert(facility).subscribe(res => {
        this.isLoading = false;
        this.translateService.get('FacilityCreate_200').subscribe(res =>
          this.matSnackBar.openFromComponent(SnackBarSuccessComponent, {
            data: res.title,
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'right'
          }));
        this.closeDialog();
      });
    }

  }

  ngOnDestroy() {
    this.isLoadingSubscription.unsubscribe();
  }

}
